import { queryOptions } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const pageQueryOptions = (slug: string) => queryOptions({
  queryKey: ["page", slug],
  queryFn: async () => {
    const { data, error } = await supabase.from("pages").select("*")
      .eq("slug", slug).eq("status", "published").maybeSingle();
    if (error) throw error;
    return data;
  },
});